export default class HeroSearch {
  static init() {
    const blocks = document.querySelectorAll('[data-module="hero-search"]');

    if (!blocks.length) {
      return;
    }

    blocks.forEach((block) => {
      block.classList.add('is-ready');

      const customSelects = block.querySelectorAll('[data-custom-select]');

      customSelects.forEach((selectRoot) => {
        HeroSearch.initCustomSelect(selectRoot);
      });
    });
  }

  static initCustomSelect(selectRoot) {
    const trigger = selectRoot.querySelector('[data-custom-select-trigger]');
    const listbox = selectRoot.querySelector('[data-custom-select-dropdown]');
    const options = Array.from(listbox.querySelectorAll('[role="option"]'));
    const hiddenInput = selectRoot.querySelector('[data-custom-select-input]');
    const valueDisplay = selectRoot.querySelector('[data-custom-select-value]');

    if (!trigger || !listbox || !hiddenInput) return;

    let isOpen = false;
    let activeIndex = options.findIndex(opt => opt.getAttribute('aria-selected') === 'true');

    // Ensure options have IDs for aria-activedescendant
    options.forEach((option) => {
      if (!option.id) {
        option.id = `option-${Math.random().toString(36).substr(2, 9)}`;
      }
    });

    // 1. Toggle Dropdown
    const toggleListbox = (open) => {
      isOpen = open;

      if (isOpen) {
        // Close other open selects globally before opening this one
        document.querySelectorAll('[data-custom-select].is-open').forEach(other => {
          if (other === selectRoot) return;
          other.dispatchEvent(new CustomEvent('closeCustomSelect'));
        });

        selectRoot.classList.add('is-open');
      } else {
        selectRoot.classList.remove('is-open');
      }

      trigger.setAttribute('aria-expanded', isOpen);
      
      if (isOpen) {
        listbox.focus();
        if (activeIndex === -1) activeIndex = 0;
        updateActiveOption();
      } else {
        trigger.focus();
      }
    };

    // 2. Visual focus for keyboard navigation
    const updateActiveOption = () => {
      options.forEach((opt, index) => {
        if (index === activeIndex) {
          opt.style.backgroundColor = 'var(--color-3--1, #F6EDE4)'; // Highlight style
          listbox.setAttribute('aria-activedescendant', opt.id);
        } else {
          opt.style.backgroundColor = '';
        }
      });
    };

    // 3. Select an option
    const selectOption = (index) => {
      if (index < 0 || index >= options.length) return;
      
      const selectedOpt = options[index];
      const value = selectedOpt.dataset.value;
      const text = selectedOpt.textContent.trim();

      // Update ARIA
      options.forEach(opt => opt.setAttribute('aria-selected', 'false'));
      selectedOpt.setAttribute('aria-selected', 'true');

      // Update Display and Hidden Input
      valueDisplay.textContent = text;
      hiddenInput.value = value;
      
      // Close dropdown
      toggleListbox(false);
      
      // Dispatch change event on hidden input in case backend scripts listen to it
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    // 4. Close when clicking outside
    document.addEventListener('click', (e) => {
      if (isOpen && !selectRoot.contains(e.target)) {
        toggleListbox(false);
      }
    });

    // 5. Trigger Click
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      toggleListbox(!isOpen);
    });

    // 6. Keyboard Navigation on Trigger
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleListbox(true);
      }
    });

    // 7. Keyboard Navigation inside Listbox
    listbox.addEventListener('keydown', (e) => {
      if (!isOpen) return;

      switch (e.key) {
        case 'Escape':
          e.preventDefault();
          toggleListbox(false);
          break;
        case 'ArrowUp':
          e.preventDefault();
          if (activeIndex > 0) {
            activeIndex--;
            updateActiveOption();
          }
          break;
        case 'ArrowDown':
          e.preventDefault();
          if (activeIndex < options.length - 1) {
            activeIndex++;
            updateActiveOption();
          }
          break;
        case 'Enter':
        case ' ':
          e.preventDefault();
          selectOption(activeIndex);
          break;
        case 'Home':
          e.preventDefault();
          activeIndex = 0;
          updateActiveOption();
          break;
        case 'End':
          e.preventDefault();
          activeIndex = options.length - 1;
          updateActiveOption();
          break;
      }
    });

    // 8. Click & Hover on Options
    options.forEach((option, index) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        selectOption(index);
      });
      
      option.addEventListener('mouseenter', () => {
        activeIndex = index;
        updateActiveOption();
      });
    });

    // Allow other instances to request this listbox to close
    selectRoot.addEventListener('closeCustomSelect', () => {
      if (isOpen) toggleListbox(false);
    });
  }
}